import React from "react";
import useTrustIcons from "../TrustIcons/useTrustIcons";
import { PAYMENT_MODES_ICONS, SSL_CHECKOUT_ICON } from "./data";
import moduleStyle from "./Style.module.scss";

const SslSection = () => {
    const { hideTrustmarkerIcons } = useTrustIcons();

    if (hideTrustmarkerIcons === true) return null;
    return (
        <div className={`${moduleStyle.container} mt-4 mt-md-0 mb-4 mb-md-0`}>
            <div className={`${moduleStyle.title}`}>ACCEPTED PAYMENTS</div>
            <div
                className={`  d-flex justify-content-between align-items-center `}
            >
                <div className={`d-flex align-items-center `}>
                    {Object.values(PAYMENT_MODES_ICONS).map(item => (
                        <img
                            key={item.alt}
                            src={item.src}
                            alt={item.alt}
                            className={`${moduleStyle.paymentIcon} mr-1`}
                        />
                    ))}
                </div>
                <img
                    src={SSL_CHECKOUT_ICON.src}
                    alt={SSL_CHECKOUT_ICON.alt}
                    className={`${moduleStyle.sslIcon}`}
                />
            </div>
        </div>
    );
};

export default SslSection;
